/**
 * Formateadores numéricos siguiendo la norma RAE / SI:
 * separador de miles = espacio fino no separable (U+00A0), no punto ni coma.
 *   3 600 000      ← número entero
 *   3 600 000,50   ← con decimales (separador decimal = coma, locale es-CO)
 *   $ 3 600 000    ← moneda COP (sin decimales)
 *
 * Implementación: tomamos el resultado de Intl.NumberFormat('es-CO', ...) que
 * usa punto como separador de miles, y lo sustituimos por espacio fino.
 * Mantenemos el redondeo nativo y la posición del símbolo de moneda.
 */

const NBSP = ' ';

export function formatNumberRAE(value, digits = 2) {
    const n = Number(value);
    if (!isFinite(n)) return '—';
    const formatted = n.toLocaleString('es-CO', {
        maximumFractionDigits: digits,
        minimumFractionDigits: 0,
    });
    return formatted.replace(/\./g, NBSP);
}

export function formatCurrencyRAE(value, currency = 'COP') {
    const n = Number(value);
    if (!isFinite(n)) return '—';
    const formatted = new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency,
        maximumFractionDigits: 0,
    }).format(n);
    return formatted.replace(/\./g, NBSP);
}

export default { formatNumberRAE, formatCurrencyRAE };
